import script from "./DoctorListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorListComponent.vue?vue&type=script&setup=true&lang=js"

import "./DoctorListComponent.vue?vue&type=style&index=0&id=dce712e2&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce712e2"]])

export default __exports__